import { createContext, useContext } from 'react';

import { type createTransactionLineItemsStore } from '.';

export const TransactionLineItemsStoreContext = createContext<ReturnType<
  typeof createTransactionLineItemsStore
> | null>(null);

export const useTransactionLineItemsStore = () => {
  const value = useContext(TransactionLineItemsStoreContext);
  if (!value) {
    throw new Error(
      'useAmountValidationStoreContext must be used within a AmountValidationStoreContext.Provider',
    );
  }
  return value;
};
